export default "__VITE_ASSET__059ce61a__"